import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	title: {
		fontWeight: 700,
		letterSpacing: ".2px",
		lineHeight: 1.15,
		margin: 0,
		[theme.breakpoints.down("sm")]: {
			fontSize: "1.25rem",
		},
	},
}));

export default function Title(props) {
	const classes = useStyles();

	return (
		<Typography variant="h5" color="primary" className={classes.title}>
			{props.children}
		</Typography>
	);
}
